import React from "react";
import { TextField, IconButton, MenuItem } from "@mui/material";
import { AddCircle, Delete } from "@mui/icons-material";
import { Autocomplete } from "@mui/material";

const BulkOrderItemsTable = ({
  products,
  orderItems,
  setOrderItems,
  darkMode,
}) => {
  const handleChange = (index, field, value) => {
    const updatedItems = [...orderItems];
    const item = updatedItems[index];

    // Material változtatása
    if (field === "productId" && index !== 0 && !item.productId) {
      const lastProductId = orderItems[orderItems.length - 1]?.productId;
      item.productId = lastProductId || value;
      item.materialName =
        products.find((p) => p.id === item.productId)?.name || "";
    } else {
      // Numerikus mezők: quantityMP, quantityML, quantityBUC -> mindig float (vagy null/empty)
      if (["quantityMP", "quantityML", "quantityBUC"].includes(field)) {
        item[field] = value === "" ? "" : parseFloat(value);

        // Ha a quantityMP-t írtuk át -> az a fő érték, akkor törölni kell a length/width/quantity mezőket
        if (field === "quantityMP") {
          item.isManualMP = true;
          item.length = "";
          item.width = "";
          item.quantity = "";
        }
      } else {
        // Nem numerikus mező -> csak úgy ahogy van
        item[field] = value;

        // Ha hossz / szélesség / quantity változott -> újraszámol MP
        if (["length", "width", "quantity"].includes(field)) {
          item.isManualMP = false;

          if (item.length && item.width && item.quantity) {
            const mp =
              (parseFloat(item.length) *
                parseFloat(item.width) *
                parseInt(item.quantity)) /
              10000;
            item.quantityMP = parseFloat(mp.toFixed(4));
          } else {
            item.quantityMP = 0;
          }
        }
      }
    }

    setOrderItems(updatedItems);
  };

  const handleAddRow = () => {
    setOrderItems([
      ...orderItems,
      {
        productId: orderItems[orderItems.length - 1]?.productId || "", // Az utolsó sor anyagát vesszük
        materialName: orderItems[orderItems.length - 1]?.materialName || "",
        length: "",
        width: "",
        quantity: "",
        quantityMP: "",
        quantityML: "",
        quantityBUC: "",
        bizot: "",
        isManualMP: false,
      },
    ]);
  };

  const handleDeleteRow = (index) => {
    const updatedItems = [...orderItems];
    updatedItems.splice(index, 1);
    setOrderItems(updatedItems);
  };

  const totalMP = orderItems
    .reduce((acc, item) => acc + (parseFloat(item.quantityMP) || 0), 0)
    .toFixed(4);

  return (
    <div className="overflow-x-auto">
      <table
        className={`w-full border shadow-lg text-sm ${
          darkMode
            ? "border-gray-700 bg-gray-900 text-gray-300"
            : "border-gray-300 bg-white text-gray-900"
        }`}
      >
        <thead>
          <tr
            className={`${
              darkMode ? "bg-gray-700 text-white" : "bg-gray-200 text-gray-900"
            }`}
          >
            <th className="border p-2 w-[15%]">Material</th>
            <th className="border p-2 w-[8%]">Lungime</th>
            <th className="border p-2 w-[8%]">Latime</th>
            <th className="border p-2 w-[8%]">Bucăți</th>
            <th className="border p-2 w-[10%]">MP</th>
            <th className="border p-2 w-[8%]">ML</th>
            <th className="border p-2 w-[8%]">BUC</th>
            <th className="border p-2 w-[23%]">Bizot</th>
            <th className="border p-2 w-[5%]">Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {orderItems.map((item, index) => {
            const product = products.find((p) => p.id === item.productId);
            const unitType = product?.unitType;

            return (
              <tr key={index}>
                <td className="border p-1 min-w-[350px] max-w-[500px]">
                  <Autocomplete
                    options={products}
                    getOptionLabel={(option) => option.name}
                    value={
                      products.find((p) => p.id === item.productId) || null
                    }
                    onChange={(event, newValue) => {
                      handleChange(index, "productId", newValue?.id || "");
                      handleChange(index, "materialName", newValue?.name || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Selectează materialul"
                        variant="standard"
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          disableUnderline: true,
                        }}
                        inputProps={{
                          ...params.inputProps,
                          style: { textAlign: "center" },
                        }}
                      />
                    )}
                    sx={{
                      "& .MuiAutocomplete-inputRoot": {
                        paddingLeft: "6px",
                        textAlign: "center",
                      },
                    }}
                    // slotProps={{
                    //   popper: {
                    //     modifiers: [
                    //       {
                    //         name: "offset",
                    //         options: {
                    //           offset: [0, 4],
                    //         },
                    //       },
                    //       {
                    //         name: "width",
                    //         enabled: true,
                    //         phase: "beforeWrite",
                    //         requires: ["computeStyles"],
                    //         fn({ state }) {
                    //           state.styles.popper.width = "320px"; // Itt állítod a szélességet
                    //         },
                    //       },
                    //     ],
                    //   },
                    // }}
                  />
                </td>

                <td className="border p-1">
                  <TextField
                    type="number"
                    size="small"
                    variant="standard"
                    value={item.length}
                    onChange={(e) =>
                      handleChange(index, "length", e.target.value)
                    }
                    inputProps={{
                      style: { textAlign: "center" },
                    }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    disabled={unitType === "BUC"} // <-- ÚJ
                  />
                </td>
                <td className="border p-1">
                  <TextField
                    type="number"
                    size="small"
                    variant="standard"
                    value={item.width}
                    onChange={(e) =>
                      handleChange(index, "width", e.target.value)
                    }
                    inputProps={{ style: { textAlign: "center" } }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    disabled={unitType === "BUC"} // <-- ÚJ
                  />
                </td>
                <td className="border p-1">
                  <TextField
                    type="number"
                    size="small"
                    variant="standard"
                    value={item.quantity}
                    onChange={(e) =>
                      handleChange(index, "quantity", e.target.value)
                    }
                    inputProps={{ style: { textAlign: "center" } }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    disabled={unitType === "BUC"} // <-- ÚJ
                  />
                </td>
                <td className="border p-1">
                  <TextField
                    type="number"
                    size="small"
                    variant="standard"
                    value={item.quantityMP}
                    onChange={(e) =>
                      handleChange(index, "quantityMP", e.target.value)
                    }
                    inputProps={{ style: { textAlign: "center" } }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    disabled={unitType === "BUC"} // ⬅️ EZ A LÉNYEG
                  />
                </td>

                <td className="border p-1">
                  <TextField
                    type="number"
                    size="small"
                    variant="standard"
                    value={item.quantityML}
                    onChange={(e) =>
                      handleChange(index, "quantityML", e.target.value)
                    }
                    inputProps={{ style: { textAlign: "center" } }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    disabled={unitType === "BUC"} // ⬅️ EZ A LÉNYEG
                  />
                </td>
                <td className="border p-1">
                  <TextField
                    type="number"
                    size="small"
                    variant="standard"
                    value={item.quantityBUC}
                    onChange={(e) =>
                      handleChange(index, "quantityBUC", e.target.value)
                    }
                    inputProps={{ style: { textAlign: "center" } }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    disabled={unitType === "MP" || unitType === "ML"} // ⬅️ EZ A LÉNYEG
                  />
                </td>

                <td className="border p-1">
                  <TextField
                    size="small"
                    variant="standard"
                    value={item.bizot}
                    onChange={(e) =>
                      handleChange(index, "bizot", e.target.value)
                    }
                    inputProps={{ style: { textAlign: "center" } }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    multiline
                    fullWidth
                  />
                </td>
                <td className="border p-1 text-center">
                  <IconButton onClick={() => handleDeleteRow(index)}>
                    <Delete color="error" />
                  </IconButton>
                </td>
              </tr>
            );
          })}
          <tr>
            <td colSpan={6} className="text-right font-semibold p-2 pr-10">
              <span className="mr-10">
                <span className="font-bold">MP Total:</span> {totalMP}
              </span>
              <span>
                <span className="font-bold">ML Total:</span>{" "}
                {orderItems
                  .reduce(
                    (acc, item) => acc + (parseFloat(item.quantityML) || 0),
                    0
                  )
                  .toFixed(4)}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="flex justify-end mt-4">
        <button
          type="button"
          onClick={handleAddRow}
          className={`flex items-center gap-2 px-4 py-2 rounded-2xl font-semibold transition ${
            darkMode
              ? "bg-blue-700 hover:bg-blue-600 text-white"
              : "bg-blue-600 hover:bg-blue-500 text-white"
          }`}
        >
          <AddCircle />
          Adaugă rând nou
        </button>
      </div>
    </div>
  );
};

export default BulkOrderItemsTable;
